export default {
    compact: {
        about: 'About',
        archives: 'Archives',
        explore: 'Explore',
        feedback: 'Feedback',
        friends: 'Friends',
        hiddenModels: 'Hidden',
        home: 'Home',
        logIn: 'Log In',
        logOut: 'Log Out',
        lounge: 'Lounge',
        mail: 'Mail',
        members: 'Members',
        messages: 'Messages',
        missMFC: 'Miss MFC',
        modelBrowser: 'Model Browser',
        more: 'More',
        myAccount: 'Account',
        myWebcam: 'My Webcam',
        news: 'News',
        notes: 'Notes',
        privateGallery: 'Private Gallery',
        recommendations: 'Models You May Like',
        rooms: 'Rooms',
        settings: 'Settings',
        shareFeed: 'Share Feed',
        signUp: 'Sign Up',
        support: 'Support',
    },
    expanded: {
        about: 'About',
        archives: 'Chat Archives',
        explore: 'Explore',
        feedback: 'Feedback',
        friends: 'Friends',
        hiddenModels: 'Hidden Models',
        ignoredModels: 'Ignored Models',
        home: 'Home',
        logIn: 'Log In',
        logOut: 'Log Out',
        lounge: 'Lounge',
        mail: 'MFC Mail',
        messages: 'Messages',
        missMFC: 'Miss MyFreeCams',
        modelBrowser: 'Model Browser',
        more: 'More',
        myAccount: 'My Account',
        myWebcam: 'My Webcam',
        news: 'News Feed',
        notes: 'My Notes',
        privateGallery: 'Private Gallery',
        recommendations: 'Models You May Like',
        rooms: 'Rooms',
        settings: 'Settings',
        shareFeed: 'MFC Share Feed',
        signUp: 'Sign Up',
        support: 'Support',
    },
    tooltips: {
        about: 'About MyFreeCams',
        archives: 'Archived Private Shows and Chat Logs.',
        explore: 'Explore online models by interests.',
        feedback: 'Provide Feedback',
        friends: 'View and manage your friends.',
        hiddenModels: 'Manage Hidden Models',
        ignoredModels: 'Manage Ignored Models',
        home: 'View online models',
        logIn: 'Login to your account.',
        logOut: 'Log out of your account.',
        lounge: 'Checkout the premium member lounges!',
        mail: 'Click here to read and send mail to other MFC members.',
        missMFC: 'Miss MFC',
        messages: 'View your private messages.',
        members: 'Member webcams and member rooms.',
        modelBrowser: 'Browse online models by profile category.',
        more: 'View more available menu options.',
        myAccount: 'View Settings and Options for your account.',
        myWebcam: 'Broadcast your own webcam.',
        news: 'Recent News',
        notes: 'User Notepad.',
        privateGallery: 'Private Gallery',
        recommendations: 'Models You May Like',
        rooms: 'View your active rooms.',
        settings: 'View and modify settings for your model list.',
        shareFeed: 'Browse the latest photos, posts, & videos from MFC Share.',
        signUp: 'Sign Up for MyFreeCams.',
        support: 'Contact Support',
    },
}
